import AuthorizeTransaction from "../authorize-transaction/AuthorizeTransaction";

const ReviewTransaction = () => {
  return <AuthorizeTransaction isReviewTransaction={true} />;
}

export default ReviewTransaction;